import React from 'react';
import { Row, Col } from './grid';
import { Paragraph, Bold, Span } from './typography';


export default ({
  headline,
  hours,
  use,
  guests,
  glassPrGuest,
  fadoel,
  vin,
  spiritus,
  mad,
  paragraph,
}) => (
  <Col xs={12} md={6}>
    <Col xs={12} grey h100p>
      <Paragraph bold>
        {headline}<br />
        <Span fontSize="12px">(Festens længde: {hours})</Span>
      </Paragraph>
      <Row>
        <Col xs={6} md={12} lg={6}>
          <Bold>Fustager drukket:</Bold><br />
          {use}
        </Col>
        <Col xs={6} sm={3} md={4} lg={3}>
          <Bold>Gæster:</Bold><br />
          {guests}
        </Col>
        <Col xs={6} sm={3} md={4} lg={3}>
          <Bold>Glas/gæst:</Bold><br />
          {glassPrGuest}
        </Col>
        <Col xs={6} sm={3} md={4} lg={3}>
          <Bold>Fadølssalg:</Bold><br />
          {fadoel}
        </Col>
        <Col xs={6} sm={3} md={4} lg={3}>
          <Bold>Vin:</Bold><br />
          {vin}
        </Col>
        <Col xs={6} sm={3} md={4} lg={3}>
          <Bold>Spiritus:</Bold><br />
          {spiritus}
        </Col>
        <Col xs={6} sm={3} md={4} lg={3}>
          <Bold>Mad:</Bold><br />
          {mad}
        </Col>
      </Row>
      <Paragraph>
        {paragraph}
      </Paragraph>
    </Col>
  </Col>
);
